import { createRouter, createWebHistory } from 'vue-router';
import OrdersView from '../components/OrdersView.vue';
import InventoryView from '../components/InventoryView.vue';
import ProductsView from '@/components/ProductsView.vue';
import SettingsView from '../components/SettingsView.vue';
import OAuthView from '../components/OAuthView.vue';

import UserEndAgreement from '@/components/UserEndAgreement.vue';
import AppDisconnected from '@/components/AppDisconnected.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';

const routes = [
    {
        path: '/',
        name: 'Orders',
        component: OrdersView
    },
    {
        path: '/orders',
        name: 'Orders',
        component: OrdersView,
    },
    {
        path: '/inventory',
        name: 'Inventory',
        component: InventoryView,
    },
    {
        path: '/products',
        name: 'Products',
        component: ProductsView,
    },
    {
        path: '/settings',
        name: 'Settings',
        component: SettingsView,
    },
    {
        path: '/oauth',
        name: 'OAuthCallback',
        component: OAuthView,
    },
    {
        path: '/eula',
        name: 'End-User License Agreement (EULA)',
        component: UserEndAgreement,
    },
    {
        path: '/qbodisconnect',
        name: 'QBO Disconnected',
        component: AppDisconnected,
    },
    {
        path: '/privacy',
        name: 'Privacy Policy',
        component: PrivacyPolicy
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/orders', // redirect to orders if no other route is matched
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;